import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const addRowButton: SugarElementInfo = {
    name: "addRowButton",
    availableChildren: { type: AvailableChildrenType.Any },
};
